import { createElement, useState, useEffect } from 'react';
import { Button, SplitButton, Dialog } from '@alifd/next';
import './index.scss';
import { userInfo, token, pageUrl, systemType } from "../../utils/const";
import { startFlow } from "../../api/api";
const FlowAction = function FlowAction(props) {
    const [tiledList, setTiledList] = useState([]);
    const [foldList, setFoldList] = useState([]);
    const [visible, setVisible] = useState(false);
    const [actionKey, setActionKey] = useState('');
    const [iframeUrl, setIframeUrl] = useState('');
    useEffect(() => {
        if (props.actionList && props.dataSource) {
            setTiledList(filterButton(true));
            setFoldList(filterButton(false));
        }
        window.onmessage = (e) => {
            if (e.data.key === 'onAction') {
                console.log(e);
                setTimeout(() => {
                    try {
                        closeApproveModel();
                        if (props.onAction) {
                            props?.onAction();
                        }
                    }
                    catch (err) {
                        console.log(err);
                    }
                }, 1000);
            }
        };
    }, []);
    useEffect(() => {
        if (props.dataSource) {
            setIframeUrl(getIframeUrl(actionKey));
        }
    }, [actionKey]);
    useEffect(() => {
        if (props.actionList && props.dataSource) {
            setTiledList(filterButton(true));
            setFoldList(filterButton(false));
            closeApproveModel();
        }
    }, [props.dataSource]);
    const actionPermissionVerify = (actionKey) => {
        const { data = {}, entity = {}, flowTask = {} } = props.dataSource;
        const { audit, createBy } = data || {};
        const { belongCurrentUser } = flowTask || {};
        let result = true;
        const user = userInfo.sysUserCode;
        if (actionKey === 'startFlow') {
            result = ['WAIT_SUBMIT', 'REFUSE'].includes(audit) && createBy === user;
        }
        else if (actionKey === 'stopFlow') {
            result = ['WAIT_COMPLETE'].includes(audit) && createBy === user;
        }
        else {
            result = ["WAIT_COMPLETE"].includes(audit) && belongCurrentUser;
        }
        return result;
    };
    const showApproveModel = (key) => {
        setVisible(true);
        setActionKey(key);
    };
    const startFlowAction = async (dataSource, requestExtendProps) => {
        const { data } = dataSource;
        const params = {
            id: data.id,
            ...requestExtendProps
        };
        const { success, result } = await startFlow({ params });
        if (!success)
            return;
        props?.onAction();
    };
    const onActionClick = (item) => {
        const { key } = item;
        if (['stopFlow', 'approve', 'reject', 'return', 'transfer', 'delegate', 'comment'].includes(key)) {
            showApproveModel(key);
            return;
        }
        switch (key) {
            case 'stopFlow':
            case 'approve':
            case 'reject':
            case 'return':
            case 'transfer':
            case 'delegate':
            case 'comment':
                showApproveModel(key);
                break;
            case 'customAction':
                confirmAction(item, item.actionClick);
                break;
            case 'startFlow':
                confirmAction(item, startFlowAction);
                break;
        }
    };
    const confirmAction = (item, callBack) => {
        const { isConfirm, confirmConfig = {}, requestExtendProps } = item;
        const { title, content, messageProps } = confirmConfig;
        if (isConfirm) {
            Dialog.confirm({
                v2: true,
                title,
                content,
                messageProps,
                onOk: () => callBack && callBack(props.dataSource, requestExtendProps),
                onCancel: () => console.log("cancel")
            });
            return;
        }
        callBack && callBack(props.dataSource, requestExtendProps);
    };
    const closeApproveModel = () => {
        setVisible(false);
        console.log('closeApproveModel');
        if (props.onCloseModal) {
            props?.onCloseModal();
        }
    };
    const getIframeUrl = (actionKey) => {
        const { flowTask = {} } = props.dataSource;
        const { taskId, procInsId } = flowTask || {};
        return `${pageUrl}/preview.html?systemType=${systemType}&formId=1540675448563929089&taskId=${taskId}&procInsId=${procInsId}&token=${token}&actionKey=${actionKey}`;
    };
    const filterButton = (isExpand) => props.actionList.filter(item => {
        if (['customAction'].includes(item.key)) {
            return item.isExpand === isExpand && item.isShow;
        }
        return item.isExpand === isExpand && actionPermissionVerify(item.key);
    });
    const tiledButton = tiledList.map((item, index) => createElement(Button, { className: "action-button", onClick: () => onActionClick(item), key: index, size: props.size, type: item.btnType, warning: item.warning }, item.name));
    const foldMenu = (foldList.map((item, index) => createElement(SplitButton.Item, { key: index, onClick: () => onActionClick(item) }, item.name)));
    const foldButton = (createElement(SplitButton, { className: "action-button", size: props.size, label: "\u66F4\u591A" }, foldMenu));
    return (createElement("div", { className: props.fixed ? 'flow-action operation-absolute' : 'flow-action', style: { textAlign: props.align || 'left' } },
        tiledList.length ? tiledButton : '',
        foldList.length ? foldButton : '',
        createElement(Dialog, { v2: true, className: "flow-action-dialog", title: "\u6D41\u7A0B\u64CD\u4F5C", visible: visible, onClose: closeApproveModel, footer: false, width: '60%', height: '500px' },
            createElement("iframe", { className: "iframe", src: iframeUrl, height: '100%', width: '100%', frameborder: "0" }))));
};
export default FlowAction;
